import { createContext, useContext } from 'react';

export const RouterParamsContext = createContext();
export const useRouterParamsContext = () => useContext(RouterParamsContext);
